import React, { Component } from 'react'
import * as urls from '../../../constants/socials'
import { Col, Panel, Button } from 'react-bootstrap'
import Form from './ContactForm.container'
import { translate } from 'react-translate'
import { DIST_URL } from '../../../constants/api'

import './ContactForm.scss'

@translate('ContactForm')
class ContactForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }
  }

  UNSAFE_componentWillMount(){
    if (this.props.setPhone) this.props.setPhone(this.props.tel)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.tel != this.props.tel){
      if (nextProps.setPhone) nextProps.setPhone(nextProps.tel)
    }
  }

  render(){

    const { section, dir, tel, t } = this.props

    let direction =  dir ? dir : 'Tucumán 117, 1er Piso'
    let telephone = tel ? tel.replace(/(\d{4})(\d{4})/, '(5411) - $1-$2') : '(5411) - 4114-1000'

    const form = <Form textareaDefault={false} />;

    return(

      <div className='form-content'>
        <Col lg={12}>
          <div className='form-title'>{t('Contactese_con_nosotros')}</div>
          <Button bsStyle='link' className='contact-form-expand-btn visible-xs'
            onClick={() => this.setState((state) => ({ open: !state.open }))}
          >
            <i className={`fa fa-angle-${this.state.open ? 'up' : 'down'} fa-lg`} />
          </Button>
        </Col>
        <Col lg={7} md={6} sm={7} className='inputs-form hidden-xs'>
          {form}
        </Col>
        <Panel className={'visible-xs'} expanded={this.state.open}>
          <Panel.Collapse>
            <Panel.Body>
              {form}
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
        <Col lg={5} md={6} sm={5} className='form-info-col hidden-xs'>
          <div className='right-content'>
            { (section) ? <div className='cont-title'>{section}</div> : <div className='cont-title'>Casa Central</div> }
            <hr></hr>
            <div className='box-dir'>
              <i className='fa fa-map-marker fa-lg'></i>
              <p>{direction}</p>
            </div>
            <div className='box-phone'>
              <i className='fa fa-mobile fa-lg'></i>
              <p>{telephone}</p>
            </div>
            <a
              onClick={(e) => e.stopPropagation()}
              target='_blank' href={`https://api.whatsapp.com/send?phone=54911${tel || '41141000'}`}
              rel='noreferrer'
            >
              <div className='box-whatsapp'>
                <i className='fa fa-whatsapp fa-lg'></i>
                <p>Whatsapp</p>
              </div>
            </a>
            <div className='box-socials social-icons-container'>
              <a href={urls.FACEBOOK} target='_blank' rel='noreferrer'>
                <img src={DIST_URL+'/assets/images/facebook-white.png'} alt='LJRamos'/>
              </a>
              <a href={urls.INSTAGRAM} target='_blank' rel='noreferrer'>
                <img src={DIST_URL+'/assets/images/instagram-white.png'} alt='LJRamos'/>
              </a>
              <a href={urls.TWITTER} target='_blank' rel='noreferrer'>
                <img src={DIST_URL+'/assets/images/twitter-white.png'} alt='LJRamos'/>
              </a>
              <a href={urls.GOOGLE} target='_blank' rel='noreferrer'>
                <img src={DIST_URL+'/assets/images/google-plus-white.png'} alt='LJRamos'/> 
              </a>
              <a href={urls.LINKEDIN} target='_blank' rel='noreferrer'>
                <img src={DIST_URL+'/assets/images/linkedin-white.png'} alt='LJRamos'/>
              </a>
              <a href={urls.YOUTUBE} target='_blank' rel='noreferrer'>
                <img src={DIST_URL+'/assets/images/youtube-white.png'} alt='LJRamos'/>
              </a>
            </div>
          </div>
        </Col>
      </div>
    )
  }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/features/commons/ContactForm/ContactForm.component.js